export enum DEPLOY_STATUS {
  NOT_STARTED,
  PREPARED,
  DEPLOYED,
}
